module.exports = __webpack_public_path__ + "img/pay-per-click.a4991fa8.png";